import { create } from "zustand";

let timeout: string | number | NodeJS.Timeout | null | undefined = null;

interface IStore {
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
}

export const useAppLoading = create<IStore>()((set) => ({
  isLoading: false,
  setIsLoading: (isLoading) => {
    if (isLoading) {
      if (timeout) clearTimeout(timeout);
      timeout = setTimeout(() => {
        set({ isLoading: false });
      }, 15000);
    }
    set({ isLoading });
  },
}));
